export const adjustContentHeight = (windowH, content, header, footer) => {
  let h =
    windowH -
    (header.height !== "auto" ? parseInt(header.height) : 0) -
    (footer.height !== "auto" ? parseInt(footer.height) : 0);
  //margins
  let hMarginTop = header.marginTop.includes("%")
    ? windowH * (parseInt(header.marginTop) / 100)
    : parseInt(header.marginTop);
  let hMarginBottom = header.marginBottom.includes("%")
    ? windowH * (parseInt(header.marginBottom) / 100)
    : parseInt(header.marginBottom);
  h =
    h -
    (isNaN(hMarginTop) ? 0 : hMarginTop) -
    (isNaN(hMarginBottom) ? 0 : hMarginBottom);

  let cMarginTop = content.marginTop.includes("%")
    ? windowH * (parseInt(content.marginTop) / 100)
    : parseInt(content.marginTop);
  let cMarginBottom = content.marginBottom.includes("%")
    ? windowH * (parseInt(content.marginBottom) / 100)
    : parseInt(content.marginBottom);
  h =
    h -
    (isNaN(cMarginTop) ? 0 : cMarginTop) -
    (isNaN(cMarginBottom) ? 0 : cMarginBottom);

  let fMarginTop = footer.marginTop.includes("%")
    ? windowH * (parseInt(footer.marginTop) / 100)
    : parseInt(footer.marginTop);
  let fMarginBottom = footer.marginBottom.includes("%")
    ? windowH * (parseInt(footer.marginBottom) / 100)
    : parseInt(footer.marginBottom);
  h =
    h -
    (isNaN(fMarginTop) ? 0 : fMarginTop) -
    (isNaN(fMarginBottom) ? 0 : fMarginBottom);

  let cPadding = content.padding.includes("%")
    ? windowH * (parseInt(content.padding) / 100)
    : parseInt(content.padding);
  h = h - (isNaN(cPadding) ? 0 : cPadding * 2);

  return h;
};

